import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { LocationCardWrapperV2 } from 'owa-location-card-v2';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import * as React from 'react';

/**
 * Returns the location element wrapped in LocationCardWrapper card or LocationCardWrapperV2
 */
export function wrapWithLocationCard(
    name: string,
    postalAddress: PersonaPostalAddress,
    locationId: string,
    locationElement: JSX.Element,
    colorScheme: ColorScheme,
    onLocationCardUnmounted: (...args: any[]) => void,
    locationAriaLabel: string,
    phoneNumber: string,
    hoverTargetStyle?: string
): JSX.Element {
    return (
        <LocationCardWrapperV2
            name={name}
            postalAddress={postalAddress}
            key={locationId}
            locationId={locationId}
            colorScheme={colorScheme}
            onLocationCardUnmounted={onLocationCardUnmounted}
            locationAriaLabel={locationAriaLabel}
            phoneNumber={phoneNumber}
            hoverTargetStyle={hoverTargetStyle}>
            {locationElement}
        </LocationCardWrapperV2>
    );
}
